import { appCreateSlice } from '@store/rtk';

import { paymentsReceiveGetDistributionSettingsListReducer } from './payments-receive-get-distribution-settings-list';
import { paymentsSetAggregatorStateReducer } from './payments-set-aggregator-state';
import { paymentsSetDistributionSettingsProcessedItemsReducer } from './payments-set-distribution-settings-processed-items';
import { paymentsSetPaymentSystemDistributionPercentReducer } from './payments-set-payment-system-distribution-pecent';
import { paymentsSetPaymentSystemStateReducer } from './payments-set-payment-system-state';
import { PaymentsState } from './types';

export const paymentsDefaultState: PaymentsState = {
  paymentsDistributionSettingsItems: undefined,
  paymentsDistributionSettingsProcessedItems: {},
};

const paymentsSlice = appCreateSlice({
  name: 'payments',
  initialState: paymentsDefaultState,
  reducers: {
    paymentsReceiveGetDistributionSettingsList:
      paymentsReceiveGetDistributionSettingsListReducer,
    paymentsSetPaymentSystemState: paymentsSetPaymentSystemStateReducer,
    paymentsSetPaymentSystemDistributionPercent:
      paymentsSetPaymentSystemDistributionPercentReducer,
    paymentsSetAggregatorState: paymentsSetAggregatorStateReducer,
    paymentsSetDistributionSettingsProcessedItems:
      paymentsSetDistributionSettingsProcessedItemsReducer,
  },
});

export const {
  actions: {
    paymentsReceiveGetDistributionSettingsList,
    paymentsSetPaymentSystemState,
    paymentsSetPaymentSystemDistributionPercent,
    paymentsSetAggregatorState,
    paymentsSetDistributionSettingsProcessedItems,
  },
  reducer: paymentsReducer,
} = paymentsSlice;
